
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { DashboardMetrics } from './dashboard/DashboardMetrics';
import { DashboardSchedule } from './dashboard/DashboardSchedule';
import { DashboardProfile } from './dashboard/DashboardProfile';
import { FirstEmployeeSetup } from './dashboard/FirstEmployeeSetup';
import { DashboardTabs } from './dashboard/DashboardTabs';
import { DashboardHeader } from './dashboard/DashboardHeader';

export const EmployeeDashboard = () => {
  const { data: employeeCount, isLoading } = useQuery({
    queryKey: ['employee-count'],
    queryFn: async () => {
      const { count, error } = await supabase
        .from('employee_profiles')
        .select('*', { count: 'exact', head: true });
      
      if (error) throw error;
      return count || 0;
    }
  });

  const { data: profile } = useQuery({
    queryKey: ['current-employee-profile'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return null;
      
      const { data } = await supabase
        .from('employee_profiles')
        .select('*')
        .eq('user_id', user.id)
        .single();
      
      return data;
    }
  });

  // If no employees exist, show the first employee setup screen
  if (!isLoading && employeeCount === 0) {
    return <FirstEmployeeSetup />;
  }

  // Check if the current user is an admin
  const isAdmin = profile?.is_admin === true;

  return (
    <div className="space-y-6">
      <DashboardHeader 
        profile={profile} 
        isFirstUser={employeeCount === 1}
      />
      
      {isAdmin ? (
        <DashboardTabs isAdmin={isAdmin} />
      ) : (
        <div className="space-y-6">
          <DashboardMetrics />
          <DashboardProfile />
          <DashboardSchedule />
        </div>
      )}
    </div>
  );
};
